import api from './api';

export const getPlans = async () => {
  const response = await api.get('/plans');
  return response.data;
};

export const getAddons = async () => {
  const response = await api.get('/plans/addons');
  return response.data;
};

export const getPlansAdmin = async () => {
  const response = await api.get('/plans/admin');
  return response.data;
};

export const updatePlan = async (planKey, { name, price_cents, max_members, included_scans }) => {
  const response = await api.put(`/plans/admin/${planKey}`, { name, price_cents, max_members, included_scans });
  return response.data;
};

export const getAddonsAdmin = async () => {
  const response = await api.get('/plans/admin/addons');
  return response.data;
};

export const updateAddon = async (addonKey, { name, price_cents, scan_amount }) => {
  const response = await api.put(`/plans/admin/addons/${addonKey}`, { name, price_cents, scan_amount });
  return response.data;
};

export const getPurchasesPaused = async () => {
  const response = await api.get('/plans/admin/purchases-paused');
  return response.data;
};

export const updatePurchasesPaused = async (paused) => {
  const response = await api.put('/plans/admin/purchases-paused', { paused });
  return response.data;
};

export const getTrialSettings = async () => {
  const response = await api.get('/plans/admin/trial-settings');
  return response.data;
};

export const updateTrialSettings = async (enabled, days) => {
  const response = await api.put('/plans/admin/trial-settings', { enabled, days });
  return response.data;
};
